import angular from 'angular'
import template from './noResPage.html'

const noresPageModule = angular
    .module('app.noresPage', [])

noresPageModule.directive('noresPage', () => ({
    scope: {
        resData: '=',
        showWhile: '=',
        isPopWindow:'@'
    },
    template,
    link(scope) {
        scope.$watch('resData', () => {
            scope.showWhile = false
            setTimeout(() => {
                if (!scope.resData || scope.resData.length === 0) {
                    scope.showWhile = true
                } else {
                    scope.showWhile = false
                }
                scope.$apply(() => {
                    scope.showWhile = scope.showWhile
                })
            }, 500)
        })
        scope.emptyText = scope.isPopWindow ? '数据为空' : '数据为空，请重新设置搜索条件'
    },
}))
export default noresPageModule.name



// WEBPACK FOOTER //
// ./src/components/noResPage/index.js